import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ForgeSelect } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';

import * as filters from 'common/components/AssetBrowser/actions/filters';
import { selectAuthority } from 'common/components/AssetBrowser/selectors/filters';
import { AUTHORITY_OFFICIAL, AUTHORITY_COMMUNITY } from 'common/components/AssetBrowser/lib/constants';

export const AuthorityFilter = () => {
  const authority = useSelector(selectAuthority);
  const dispatch = useDispatch();

  const changeAuthority = (value) => {
    dispatch(filters.changeAuthority(value));
  };

  const scope = 'shared.asset_browser.filters.authority';

  const authorityOptions = [
    { label: I18n.t('options.all', { scope }), value: null },
    {
      label: I18n.t('options.official', { scope }),
      value: AUTHORITY_OFFICIAL,
      leadingIcon: 'check_decagram',
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.community', { scope }),
      value: AUTHORITY_COMMUNITY,
      leadingIcon: 'account_group',
      leadingIconType: 'component',
    },
  ];

  const labelText = I18n.t('label', { scope });

  return (
    <div className="filter-section authority">
      <label className="filter-label">{labelText}</label>
      <ForgeSelect
        value={authority || null}
        variant="filled"
        onChange={(event) => changeAuthority(event.detail || null)}
        options={authorityOptions}
      />
    </div>
  );
};

export default AuthorityFilter;
